import { reducer as questionnaires } from "@teamprevent/common/questionnaires/reducer";
import { reducer as questionnaireConfigs } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { reducer as physiotherapyReferralForm } from "@teamprevent/common/questionnaires/components/physiotherapyReferralForm/reducer";
import { ReducersMapObject } from "redux";

import { reducer as currentUser } from "./auth";
import { reducer as customerDetails } from "./customer";
import { ohCases } from "./ohCase/reducer";
import { reducer as actionableTasks } from "./actionableTasks";
import { reducer as ppqReports } from "./ppq";
import { reducer as allowedPhysioOrigins } from "./allowedPhysioOrigins";
import { reducer as immunisations } from "./immunisationHistory";
import { reducer as employeeRecords } from "./employeeRecord";
import { ApplicationState } from "./applicationState";
import { customMedicalTypes } from "./customMedicalTypes/reducer";

export const reducers: ReducersMapObject<
    Omit<ApplicationState, "loading" | "router">,
    any
> = {
    currentUser,
    ohCases,
    questionnaires,
    actionableTasks,
    ppqReports,
    questionnaireConfigs,
    customerDetails,
    allowedPhysioOrigins,
    physiotherapyReferralForm,
    immunisations,
    employeeRecords,
    customMedicalTypes
};
